import { Component } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { LearningUserFlat } from '../../shared/learning-user-flat.model';

@Component({
    selector: 'app-edit-external-users',
    templateUrl: './edit-external-users.component.html',
    styleUrls: ['./edit-external-users.component.scss']
  })
  export class EditExternalUsersComponent extends ComponentView {

    listData: LearningUserFlat[];
    table: TableData;

    async initParams(): Promise<boolean> {
        this.listData = await this.app.loadDataHandler(async () => RestEndpoint.main().find({source: "learnExternal"}).run("api/lrn/learninguserflat").list(LearningUserFlat), this);

         this.table = new TableData([
            new TableColumn("lastName", "Nachname"),
            new TableColumn("firstName", "Vorname"),
            new TableColumn("email", "E-Mail"),
            new TableColumn("isAdmin", "Administrator", TableCellType.yesNo),
            new TableColumn("mayCreateItems", "Darf Lerninhalte anlegen", TableCellType.yesNo),
            new TableColumn("mayModifyItems", "Darf Lerninhalte bearbeiten", TableCellType.yesNo),
            new TableColumn("mayRunAnalyses", "Darf Auswerten", TableCellType.yesNo)
        ], this.listData.map(o => new TableRow("", o, {
            lastName: o.lastName,
            firstName: o.firstName,
            email: o.email,
            isAdmin: o.isAdmin,
            mayCreateItems: o.mayCreateItems,
            mayModifyItems: o.mayModifyItems,
            mayRunAnalyses: o.mayRunAnalyses
        })), [new TableSortColumn("lastName"), new TableSortColumn("firstName")]);
        this.app.updateNavigation(null, [
            { label: "Administration", routerLink: ["/enaio-learn", "admin"] },
            { label: "Externe Benutzer", routerLink: ["/enaio-learn", "admin", "external-users"] }
        ]);
        return true;
    }
}
